interface getFormattedPriceArgs {
  price: number;
}

export const getFormattedPrice = ({ price }: getFormattedPriceArgs) => {
  const payload = price?.toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP',
  });
  return payload;
};
